module.exports = __webpack_public_path__ + "img/pet7.07321c67.png";